// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__H3uqS","name":"styles_name__1wnTO","phone":"styles_phone__1zUcD"};